import { useEffect, useState } from 'react';

import { difference, uniq } from 'lodash-es';

import { getEntityCurrentAcls } from '../ducks/common_acls/thunks';
import type { CommonAclsPrefix } from '../ducks/common_acls/types';
import { useAppDispatch, useAppSelector } from '../store/react_redux_typed';

export const useFetchMissingAcls = (
  entityType: CommonAclsPrefix,
  aclsPrefixIds: string[],
) => {
  const dispatch = useAppDispatch();

  const acls = useAppSelector(
    (state) => state.acls[entityType].entityCurrentUserAcls,
  );

  const [fetchedAclIds, setFetchedAclIds] = useState<string[]>([]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: intentionally only on ids change
  useEffect(() => {
    const ids = aclsPrefixIds.filter((id) => acls[id] === undefined);

    const missingAclIds = uniq(difference(ids, fetchedAclIds));
    if (missingAclIds.length === 0) {
      return;
    }

    setFetchedAclIds(ids.concat(fetchedAclIds));
    for (const missingAclId of missingAclIds) {
      dispatch(getEntityCurrentAcls(entityType, missingAclId));
    }
  }, [aclsPrefixIds]);
};
